import React from 'react'
import PropTypes from 'prop-types'
import getGeoInfo from '~/utils/getGeoInfo'
import { useQuery, gql } from '@apollo/client'
import { ListCard } from '~/components/ListCard'
import { Skeleton } from '~/components/ListCard/Skeleton'
import { decodeGlobalId } from '~/utils/id'
import { track } from '~/utils'
import { RECOMMENDATION_CLICKED } from '~/lib/tracking-events'
import followedArtistFragment from '~/graphql/fragments/followedArtists'
import { eventListFragment } from '~/graphql/fragments'

const GET_FOLLOWED_ARTIST_EVENTS = gql`
  query followedArtistEvents($first: Int, $latitude: Float, $longitude: Float) {
    nearby(latitude: $latitude, longitude: $longitude) {
      eventsByFollowedArtists(first: $first) {
        edges {
          node {
            ...eventList
          }
        }
      }
    }
    viewer {
      id
      followedArtists(first: 8) {
        ...followedArtists
      }
    }
  }

  ${eventListFragment}
  ${followedArtistFragment}
`

const FollowedEvents = ({ t }) => {
  const { longitude, latitude } = getGeoInfo()
  const { data, loading } = useQuery(GET_FOLLOWED_ARTIST_EVENTS, {
    variables: {
      longitude: parseFloat(longitude),
      latitude: parseFloat(latitude),
      first: 10, // No pagination has been implemented, added this to avoid excessive loading
    },
  })

  if (loading) return <Skeleton />
  if (!data) return null

  const { nearby, viewer } = data
  const { eventsByFollowedArtists } = nearby
  const { edges = [] } = eventsByFollowedArtists
  const { followedArtists } = viewer
  const { edges: artistEdges = [] } = followedArtists
  const avatars = artistEdges.map(({ node }) => node.avatar)

  if (edges.length === 0) return null

  const trackClick = eventId => {
    const clickedEvent = edges.find(({ node }) => decodeGlobalId(node.id) === eventId)

    track(RECOMMENDATION_CLICKED, {
      recommendationId: eventId,
      recommendationName: clickedEvent.node.name,
      type: 'event',
      trigger: 'FOLLOWED_ARTIST',
    })
  }

  return (
    <ListCard
      t={t}
      dialogItems={edges}
      title={t('home:followedArtistEvents.title')}
      text={t('home:followedArtistEvents.subtitle')}
      trackClick={trackClick}
      variant="AVATARS"
      thumbnailImages={avatars}
    />
  )
}

FollowedEvents.propTypes = {
  t: PropTypes.func.isRequired,
}

export default FollowedEvents
